import React, { ReactElement } from 'react';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import useStore from 'store';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import { AlertVariant } from 'types/enums';

const useStyles = makeStyles(theme => ({
  listItem: {
    minHeight: 48
  },
  listTextItem: {
    flex: 'unset',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: 190
  },
  listItemContainer: {
    display: 'flex',
    justifyContent: 'baseline'
  },
  iconButton: {
    '&:hover': {
      background: 'unset'
    },
    color: theme.palette.secondary.main,
    marginTop: -(theme.spacing(1) / 2),
    marginLeft: theme.spacing(1) / 2
  },
  visibilityOpen: {
    opacity: 1,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.short
    })
  },
  visibilityClose: {
    opacity: 0,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.short
    })
  },
  filterNoneIcon: {
    height: 16,
    width: 16
  }
}));

interface PinProps {
  pin: string;
}

const Pin = ({ pin }: PinProps): ReactElement => {
  const [, { openAlert }] = useStore();
  const classes = useStyles();
  const { t } = useTranslation('PINNavigatonItem');

  const copyPinToClipboard = (): void => {
    window.navigator.clipboard.writeText(pin);
    openAlert({
      variant: AlertVariant.SUCCESS,
      title: t('Educator PIN Copied'),
      text: t('Educator PIN has been copied to the clipboard.'),
      timer: 3000
    });
  };

  return (
    <div className={classes.listItemContainer}>
      <Typography className={clsx(classes.listTextItem)}>
        {t('PIN')}: <strong>{pin}</strong>
      </Typography>
      <IconButton
        disableRipple
        disableFocusRipple
        aria-label={t('Copy Educator PIN')}
        size="small"
        onClick={copyPinToClipboard}
        className={classes.iconButton}
      >
        <FilterNoneIcon fontSize="inherit" className={classes.filterNoneIcon} />
      </IconButton>
    </div>
  );
};

export default Pin;
